import apolloClient from '../apollo';

export const localStorage = window.localStorage;
export const sessionStorage = window.sessionStorage;

export enum STORAGE_ACTION {
  ACCESS_TOKEN = 'ACCESS_TOKEN', //헤더에 들어가는 토큰
  REFRESH_TOKEN = 'REFRESH_TOKEN'
}

export const getToken: () => string | undefined = () => {
  const accessToken = localStorage.getItem(STORAGE_ACTION.ACCESS_TOKEN);
  if (accessToken && accessToken !== null) {
    return accessToken;
  }
  return '';
};

export const authStorageClear: () => void = () => {
  localStorage.removeItem(STORAGE_ACTION.ACCESS_TOKEN);
  localStorage.removeItem(STORAGE_ACTION.REFRESH_TOKEN);
};

export const setStorageItem: (action: STORAGE_ACTION, data: any) => void = (
  action: STORAGE_ACTION,
  data: any
) => {
  localStorage.setItem(action, data);
};

export const getStorageItem: (action: STORAGE_ACTION) => string | null = (
  action: STORAGE_ACTION
) => {
  return localStorage.getItem(action);
};

export const deleteStorageItem = (action: STORAGE_ACTION) => {
  localStorage.removeItem(action);
};

export const clearStorageAll: () => void = () => {
  localStorage.removeItem(STORAGE_ACTION.ACCESS_TOKEN);
  localStorage.removeItem(STORAGE_ACTION.REFRESH_TOKEN);
  apolloClient.clearStore();
};

export const deleteSessionStorageItem: (action: STORAGE_ACTION) => void = (
  action: STORAGE_ACTION
) => {
  sessionStorage.removeItem(action);
};
